import { Component } from "react";
import { connect } from "react-redux";
import { setPassWordModalState } from "../redux-state/features/global-state/globalStateSlice";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import urls from "../urls";
import { showSuccess, showError } from "../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { setMustChangePswd } from "../redux-state/features/user/userSlice";
class ChanagePassWordModal extends Component {
  constructor() {
    super();
    this.state = {
      isButtonDisabled: true,
      password: "",
      error: "",
      inputType: "password",
    };
  }

  validatePassword = (password) => {
    if (!password.trim()) {
      this.setState({ error: "كلمة المرور مطلوبة" });
      return false;
    } else if (password.length < 8) {
      this.setState({ error: "كلمة المرور يجب أن تكون على الأقل 8 أحرف" });
      return false;
    }
    this.setState({ error: "" });
    return true;
  };

  handleSubmit = () => {
    const { password } = this.state;
    if (this.validatePassword(password)) {
      this.handlePasswordChange(password);
    }
  };

  handlePasswordChange = () => {
    const { uuid } = this.props;
    const { password } = this.state;
    axios
      .post(urls.changePswd, { uuid, password, mustChangePswd: 0 })
      .then(() => {
        showSuccess("تم تغيير كلمة المرور بنجاح");
        this.handleClose();
        const user = JSON.parse(localStorage.getItem("user"));
        const updatedObject = { ...user, mustChangePswd: 0 };
        localStorage.setItem("user", JSON.stringify(updatedObject));
      })
      .catch((err) => {
        showError("لم يتم تغيير كلمة المرور بنجاح ");
        console.error(err);
      });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      inputType: prevState.inputType === "password" ? "text" : "password",
    }));
  };

  handleClose = () => {
    this.props.setMustChangePswd(0);
  };

  render() {
    const { show } = this.props;
    const { isButtonDisabled, error, password, inputType } = this.state;
    return (
      <Modal show={show} backdrop="static">
        <Modal.Header>
          <Modal.Title>إجبارية تغيير كلمة المرور </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>يجب تعديل كلمة المرور قبل متابعة العمل</p>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col">
                <form>
                  <div className="input-group">
                    <div className="form-floating flex-grow-1">
                      <input
                        type={inputType}
                        className={`form-control ${error ? "is-invalid" : ""}`}
                        id="password"
                        placeholder="كلمة المرور الجديدة"
                        value={password}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                      />
                      <label htmlFor="password">كلمة المرور الجديدة</label>
                    </div>
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={this.togglePasswordVisibility}
                    >
                      <FontAwesomeIcon
                        icon={inputType === "password" ? faEye : faEyeSlash}
                      />
                    </span>
                  </div>

                  {error && <div className="text-danger">{error}</div>}
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={this.handleSubmit}
            disabled={password.length < 8}
          >
            حفظ التغييرات
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = { setPassWordModalState, setMustChangePswd };
const mapStateToProps = (state) => ({
  show: parseInt(state.userState.mustChangePswd) === 1,
  uuid: state.userState.uuid,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChanagePassWordModal);
